import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  imports: [CommonModule],
  selector: 'footer',
  templateUrl: './footer.template.html'
})
export class FooterComponent { }
